/** Recherche + filtres de la liste clients. */
import "./clientListBar.css";
import { SearchClear } from "../../components/SearchClear";
import { CLIENT_FILTERS, type ClientListFilter } from "./format";

type ClientListBarProps = {
  q: string;
  onQ: (v: string) => void;
  filter: ClientListFilter;
  onFilter: (id: ClientListFilter) => void;
  count?: number;
};

export function ClientListBar({ q, onQ, filter, onFilter, count }: ClientListBarProps) {
  return (
    <>
      <div className="fx-listbar">
        <label className="fx-listbar__search">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="10.5" cy="10.5" r="6.2" stroke="currentColor" strokeWidth="1.7" />
            <path d="M15.2 15.2 20 20" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
          </svg>
          <input
            className="fx-listbar__input"
            name="q"
            value={q}
            placeholder="Nom, prénom du contact, SIRET ou e-mail"
            autoComplete="off"
            aria-label="Rechercher un client"
            onChange={(e) => onQ(e.target.value)}
          />
          <SearchClear value={q} onClear={() => onQ("")} />
        </label>
        {typeof count === "number" ? (
          <span className="fx-listbar__count">
            {count} client{count === 1 ? "" : "s"}
          </span>
        ) : null}
      </div>
      <div className="fx-filters" role="group" aria-label="Filtrer les clients">
        {CLIENT_FILTERS.map((f) => (
          <button
            key={f.id}
            type="button"
            className={filter === f.id ? "is-on" : ""}
            aria-pressed={filter === f.id}
            onClick={() => onFilter(f.id)}
          >
            {f.label}
          </button>
        ))}
      </div>
    </>
  );
}
